export const ConvertProductToName = (product: string) => {
  const packageProductMap = new Map([
    ["MR", "Reunião"],
    ["PO", "Privativo"],
    ["EV", "Eventos"],
    ["WS", "Workstation"],
  ]);

  return packageProductMap.get(product) || "";
};
